import { useEffect, useState } from "react";
import Loader from "../components/Loader/Loader";
import OTPInput from "otp-input-react";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { RiLockPasswordFill } from "react-icons/ri";
import { useNavigate, useLocation } from "react-router-dom";
import { sendOTP, verifyOTP } from "../Redux/Actions/userAction";
import React from "react";

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [otp, setOtp] = useState("");
  const [counter, setCounter] = useState(120);
  const { phone, hash, email } = useSelector((state) => state.otpDetails.otp);
  const { loading } = useSelector((state) => state.otpDetails);

  const dispatch = useDispatch();

  // Expire OTP timer
  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);

    if (counter === 0) setOtp("");
    return () => clearInterval(timer);
  }, [counter]);

  // Send the otp again when otp expires
  const sendOtpAgain = async () => {
    // If user email is not given
    if (!email) return;

    // Send OTP to user
    dispatch(sendOTP(email));

    // Start the counter again
    setCounter(119);
  };

  // Verify OTP Request
  async function handleVerifyOTP() {
    // Check all data are available or not
    if (!otp || !hash || !email) return;

    // Get all the data from store and check for verify the user and
    // If user verified then navigate to requeired page
    dispatch(verifyOTP(otp, email, hash, navigate, from));
    // Clear the field
    setOtp("");
  }

  if (loading) return <Loader message="Verifying OTP..." />;

  return (
    <>
      <div className="w-full md:h-screen px-4 py-6 bg-pink-200 md:flex justify-center items-center">
        <div className="w-full md:min-h-max md:w-96 bg-yellow-100 px-8 py-8 md:px-10 md:py-10 rounded-md">
          <div className="py-3 flex items-center gap-2">
            <RiLockPasswordFill className="text-red-500 text-2xl" />
            <h1 className="text-lg font-bold text-jet ">Verify with OTP</h1>
          </div>
          <h2 className="text-sm font-normal text-gray-400">
            sent to{" "}
            <span className="font-semibold text-green text-green-500">
              {email}
            </span>
          </h2>
          <div className="my-5">
            <OTPInput
              inputStyle={{
                width: "3rem",
                height: "3rem",
                margin: "0 .5rem",
                fontSize: "2rem",
                backgroundColor: "#173954",
                borderRadius: 4,
                focus: "none",
                border: "1px solid rgba(0,0,0,0.2)",
              }}
              value={otp}
              onChange={setOtp}
              autoFocus
              OTPLength={4}
              otpType="number"
              disabled={false}
            />
          </div>
          <div className="flex justify-start">
            <button
              text="Verify"
              className="py-1.5 px-4 bg-pink-500 rounded-sm w-24"
              onClick={handleVerifyOTP}
            >
              Verify
            </button>
          </div>
          <h1>
            {counter > 0 ? (
              <button className="text-sm font-normal text-gray-400 my-4">
                Resend OTP in{" "}
                <span className=" pl-1 font-bold text-jet">{counter}</span>{" "}
              </button>
            ) : (
              <>
                <button
                  className="text-pink-500 font-semibold text-md pt-2 hover:text-blue-800 cursor-pointer"
                  onClick={sendOtpAgain}
                >
                  Resend OTP
                </button>
              </>
            )}
          </h1>
          <h1>
            <button className="text-sm font-normal text-gray-400 my-4">
              log in using{" "}
              <span className="font-bold text-pink-500">Password</span>
            </button>
          </h1>
          <h1>
            <button className="text-sm font-normal text-gray-400 my-4">
              Having trouble logging in ?{" "}
              <span className="font-bold text-pink-500">Get help</span>
            </button>
          </h1>
        </div>
      </div>
    </>
  );
};

export default VerifyOtp;
